import { State } from './state';

/**
 * Represente les données d'une étape de workflow.
 */
export class StepData {
    /**
     * Id de l'étape.
     */
    id: number;

    /**
     * Les états utilisé par cette étape de workflow.
     */
    public states: State[];

    /**
     * Nom de l'étape
     */
    public stepName: string;

    /**
     * @param order : L'ordre de l'étape.
     */
    public order: number;

    /**
     * @param maxDuration : La durée maximale du wrokflow (en heures).
     */
    public maxDuration: number;

    /**
     * Constructeur.
     */
    public constructor() {}

    /**
     * Retourne une copie d'une instance de StepData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: StepData) {
        if (!!other) {
            const instance = new StepData();
            instance.stepName = other.stepName;
            instance.order = other.order;
            instance.maxDuration = other.maxDuration;
            instance.states = State.cloneArray(other.states);

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de StepData
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: StepData[]) {
        if (!!others) {
            let stepDatas: StepData[] = [];

            others.forEach((x) => {
                const stepData = StepData.clone(x);
                stepDatas.push(stepData);
            });

            return stepDatas;
        } else {
            return [];
        }
    }
}
